/* Four Cards → Modal (no deps)
   - Binds click / Enter / Space to open
   - ESC & backdrop click to close
   - Focus trap; returns focus to opener
   - Deep link: ?modal=<block_id or dialog id>
*/
(function () {
  'use strict';

  const SELECTOR_SECTION = '[data-fourcards-sid]';

  const FOCUSABLE = [
    'a[href]',
    'area[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function qsa(el, sel) { return Array.prototype.slice.call(el.querySelectorAll(sel)); }

  function openDialog(section, dialog, trigger) {
    if (!dialog) return;
    dialog.hidden = false;
    dialog.setAttribute('data-open', 'true');
    // remember trigger for return focus
    section._fourcardsLastTrigger = trigger || null;

    // focus first focusable or the close button
    const box = dialog.querySelector('.yr-fourcards__dlg-box');
    const focusables = qsa(box, FOCUSABLE);
    (focusables[0] || box).focus();

    // trap focus
    dialog._fourcardsKeyHandler = function (e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeDialog(section, dialog);
        return;
      }
      if (e.key === 'Tab') {
        const nodes = qsa(box, FOCUSABLE);
        if (nodes.length === 0) {
          e.preventDefault();
          return;
        }
        const first = nodes[0];
        const last = nodes[nodes.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }
    };
    document.addEventListener('keydown', dialog._fourcardsKeyHandler);

    // backdrop click
    dialog._fourcardsClickHandler = function (e) {
      const backdrop = e.target.closest('[data-backdrop]');
      const boxEl = e.target.closest('.yr-fourcards__dlg-box');
      if (backdrop && !boxEl) {
        closeDialog(section, dialog);
      }
    };
    dialog.addEventListener('click', dialog._fourcardsClickHandler, { passive: true });
  }

  function closeDialog(section, dialog) {
    if (!dialog) return;
    dialog.setAttribute('data-open', 'false');
    dialog.hidden = true;

    // remove handlers
    document.removeEventListener('keydown', dialog._fourcardsKeyHandler || (()=>{}));
    dialog.removeEventListener('click', dialog._fourcardsClickHandler || (()=>{}));
    dialog._fourcardsKeyHandler = null;
    dialog._fourcardsClickHandler = null;

    // return focus
    if (section._fourcardsLastTrigger && typeof section._fourcardsLastTrigger.focus === 'function') {
      section._fourcardsLastTrigger.focus();
    }
    section._fourcardsLastTrigger = null;
  }

  function bindSection(section) {
    const triggers = qsa(section, '[data-modal-target]');
    const sid = section.getAttribute('data-fourcards-sid');

    // open handlers
    triggers.forEach(btn => {
      const targetSel = btn.getAttribute('data-modal-target');
      const dialog = section.querySelector(targetSel);

      function onActivate(e) {
        // support Enter/Space when element is not a native button
        if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        openDialog(section, dialog, btn);
      }

      btn.addEventListener('click', onActivate);
      btn.addEventListener('keydown', onActivate);
    });

    // per-dialog close button
    qsa(section, '.yr-fourcards__dlg .yr-fourcards__dlg-x').forEach(closeBtn => {
      closeBtn.addEventListener('click', function (e) {
        const dialog = e.target.closest('.yr-fourcards__dlg');
        closeDialog(section, dialog);
      });
    });

    // deep link: ?modal=<block_id or dialog id>
    try {
      const params = new URLSearchParams(window.location.search);
      const modalParam = params.get('modal');
      if (modalParam) {
        // match by data-block-id or by id
        let dialog = section.querySelector(`.yr-fourcards__dlg[data-block-id="${modalParam}"]`);
        if (!dialog) dialog = section.querySelector(`.yr-fourcards__dlg#${CSS.escape(modalParam)}`);
        if (dialog) {
          // open after paint to ensure styles applied
          requestAnimationFrame(() => openDialog(section, dialog, null));
        }
      }
    } catch (e) { /* noop */ }
  }

  function init() {
    qsa(document, SELECTOR_SECTION).forEach(bindSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
